<ng-container *ngIf="isLoaded()">
  <!-- Formularios en tarea o en modal sin wrapper -->
  <ng-container *ngIf="(windowHash); else templateWrapper">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-container>
  <ng-template #templateWrapper>
    <div class="wrapper wrapper-content BASEFORMINMODAL" *ngIf="!windowHash">
      <ng-container *ngTemplateOutlet="contractInfo"></ng-container>
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="antecedentTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template #contractInfo>
    <ng-container *ngIf="contract">
      <!--<contractHeader [contractIdentifier]="contractId"></contractHeader>-->
      <contractHeader [contract]="contract"></contractHeader>
    </ng-container>
  </ng-template>
  <!-- <ng-template #contractInfo>
    <ng-container *ngIf="contract">
      <p-panel [toggleable]="true">
        <p-header><i class="fas fa-file-contract"></i> {{contract.abbreviatedTitle}}</p-header>
        <div class="row" *ngIf="isLoaded()">
          <dl class="col-12 col-sm-6 p-0 m-0">

            <ng-container>
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Sistema Inscripción Contrato' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{(contract.isProjectReplyca)?'REPLYCA':'RECON'}}</dd>
            </ng-container>
            <ng-container *ngIf="contract?.registrationNumber">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Contracts.registerNumber' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ contract.registrationNumber }}</dd>
            </ng-container>
            <ng-container
              *ngIf="contract?.contractLots !== undefined && contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId!== 0">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Lote del Contrato' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ contract.contractLots[0].lot.lotNumber }}</dd>
            </ng-container>
            <ng-container *ngIf="isBasedContract && contract?.userOrderNumber">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Nº de orden interno del Contrato Basado' | translate }}
              </dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ contract.userOrderNumber }}</dd>
            </ng-container> -->
  <!-- centro seccion y unidad de contratacion-->
  <!-- <ng-container
              *ngIf="contract?.organizationalInfo?.centerSectionCode && contract?.organizationalInfo?.centerSectionCode.description">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Centro - seccion' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ contract?.organizationalInfo?.centerSectionCode.description
                }}
              </dd>
            </ng-container>
            <ng-container
              *ngIf="contract?.organizationalInfo?.contractingUnit && (contract?.organizationalInfo?.contractingUnit.name || contract?.organizationalInfo?.contractingUnit.identifier) ">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Unidad de contratación' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">
                {{(contract.isProjectReplyca)?contract?.organizationalInfo?.contractingUnit.name:contract?.organizationalInfo?.contractingUnit.identifier}}
              </dd>
            </ng-container>
            <ng-container
              *ngIf="isCBAM && contract?.contractLots[0]?.lot && contract?.contractLots[0]?.lot.lotId!== 0 && contract?.procurementProjectInfo.title">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Título Abreviado del Contrato Basado' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ contract.procurementProjectInfo.title }}</dd>
            </ng-container>
            <ng-container *ngIf="contract?.plannedPeriod.registrationDate">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Fecha de Inscripción' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block"> <i class="fas fa-calendar-alt"></i> {{
                contract?.plannedPeriod.registrationDate | date:'dd/MM/yyyy'}} </dd>
            </ng-container>
          </dl>
          <dl class="col-12 col-sm-6 p-0 m-0"> -->
  <!-- Datos del adjudicatario -->
  <!-- <ng-container *ngIf="actualCompanyDoc">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'NIF/CIF del adjudicatario' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block"><i class=" far fa-credit-card"></i> {{
                actualCompanyDoc.taxIdentifier }}</dd>
            </ng-container>
            <ng-container *ngIf="actualCompanyDoc">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Nombre o den. social del adjudicatario' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ actualCompanyDoc.name }}</dd>
            </ng-container>
            <ng-container *ngIf="actualCompanyDoc">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Tipo persona' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">
                <ng-container *ngIf="actualCompanyDoc?.companyTypeDesc">
                  {{ actualCompanyDoc.companyTypeDesc }}
                </ng-container>
                <ng-container *ngIf="contract?.company?.society?.description">- {{ contract.company.society.description
                  }}
                </ng-container>
              </dd>
            </ng-container>
            <ng-container *ngIf="actualCompanyDoc?.nationalityDesc">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'Nacionalidad del adjudicatario' | translate }}</dt>
              <dd class="col-12 col-md-6 d-inline-block">{{ actualCompanyDoc.nationalityDesc }}</dd>
            </ng-container>
            <ng-container *ngIf="actualCompanyDoc?.pyme">
              <dt class="col-12 col-md-6 d-inline-block">{{ 'PYME' | translate }}</dt> -->
  <!--<dd class="col-12 col-md-6 d-inline-block">{{ contract.contractClassification.pyme }}</dd>-->
  <!-- <dd class="col-12 col-md-6 d-inline-block">{{(actualCompanyDoc?.pyme)?'Sí':'No'}}</dd>
            </ng-container>
            <ng-container *ngIf="actualCompanyDoc?.temporaryConsortium">
              <p-panel>
                <p-header>Componentes de la UTE</p-header> -->
  <!--<dd class="col-6">{{ contract.company.temporaryConsortium }}</dd>-->
  <!-- <p-table #dt [value]="actualCompanyDoc?.consortiumParticipations" [paginator]="false"
                  [scrollable]="false" [resizableColumns]="true"> -->
  <!-- sortField="expedienteId" sortOrder="1"
                >-->
  <!-- <ng-template pTemplate="header">
                    <tr>
                      <th [pSortableColumn]="'name'"> {{ 'Nombre' | translate }} </th>
                      <th [pSortableColumn]="'taxIdentifier'"> {{ 'NIF/CIF' | translate }} </th>
                      <th [pSortableColumn]="'typeDesc'"> {{ 'Tipo Persona' | translate }} </th>
                      <th [pSortableColumn]="'nacionalidad'"> {{ 'Nacionalidad' | translate }} </th>
                      <th [pSortableColumn]="'percentage'"> {{ 'Porcentaje' | translate }} </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-consortiumParticipation>
                    <tr>
                      <td field="name"> {{consortiumParticipation.name}} </td>
                      <td field="taxIdentifier"> {{consortiumParticipation.taxIdentifier}} </td>
                      <td field="typeDesc"> {{consortiumParticipation.typeDesc}} </td>
                      <td field="nationalityDesc">
                        {{ consortiumParticipation.nationalityDesc}} </td>
                      <td field="percentage"> {{consortiumParticipation.percentage}}%</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-panel>
            </ng-container>
          </dl>
        </div>
      </p-panel>
    </ng-container>
  </ng-template> -->
  <ng-template #formTemplate>
    <!-- COMENTARIO DE RECHAZO PARA FORMULARIOS QUE GESTIONAN DOCUMENTOS -->
    <div #rejectionPanelContainer></div>
    <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
  </ng-template>
  <!-- ANTECEDENTES
  <ng-template #antecedentTemplate>
    <ng-container *ngIf="contract">
      <div class="p-table-wrapper">
        <p-table [value]="antecedents" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'20%'" [pSortableColumn]="false" class="TEXTTH th-wrap ">
                {{'Incidencia'|translate}}</th>
              <th [style.width]="'30%'" [pSortableColumn]="false" class="DATETH th-wrap "
                pTooltip="{{formService.getDescriptionCol(this, col)}}" tooltipPosition="top">{{'Fecha Aprobación'|
                translate}}</th>
              <th [style.width]="'20%'" [pSortableColumn]="false" class="CURRENCYTH th-wrap "
                pTooltip="{{formService.getDescriptionCol(this, col)}}" tooltipPosition="top">{{'Presupuesto
                (+IVA)'|translate}}</th>
              <th [style.width]="'30%'" [pSortableColumn]="false" class="CURRENCYTH th-wrap "
                pTooltip="{{formService.getDescriptionCol(this, col)}}" tooltipPosition="top">{{'Precio (+IVA)'|
                translate}}</th>
              <th [style.width]="'30%'" [pSortableColumn]="false" class="TH th-wrap "
                pTooltip="{{formService.getDescriptionCol(this, col)}}" tooltipPosition="top">{{'Plazo (Meses)'|
                translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-antecedent>
            <tr>
              <td><span class="p-column-title">{{'Incidencia'|translate}}</span> {{antecedent.description}} </td>
              <td><span class="p-column-title">{{'Fecha de Aprobación'| translate}}</span> {{antecedent.agreementDate
                | date: 'dd/MM/yyyy'}}</td>
              <td><span class="p-column-title">{{'Presupuesto (+IVA)'| translate}}</span> {{antecedent.budget |
                currency: 'EUR'}}</td>
              <td><span class="p-column-title">{{'Precio (+IVA)'| translate}}</span> {{antecedent.price | currency:
                'EUR' }}</td>
              <td><span class="p-column-title">{{'Precio (+IVA)'| translate}}</span> {{antecedent.period | currency:
                'EUR'}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </ng-template>-->
</ng-container>